export default __webpack_public_path__ + "774991836ea20b85dcc9faa494254282.svg";